<div class="galleries">
  @for (gallery of galleries; track gallery.id) {
  <a [routerLink]="links[gallery.id]" [target]="embedMode ? '_blank' : '_self'">
    <app-gallery-item [gallery]="gallery" [publicMode]="true"> </app-gallery-item>
  </a>
  }
</div>
